class CartWatcher {
    init() {
        this.emitCartChanges().then(() => {
            this.observeCartChanges();
        });
    }
    async fetchCart() {
        try {
            let t = await fetch("/cart.js");
            return t.json();
        } catch (e) {
            throw (console.error("Error fetching cart:", e), e);
        }
    }
    storeCart(t) {
        localStorage.setItem("cart", JSON.stringify(t));
    }
    storedCart() {
        return JSON.parse(localStorage.getItem("cart")) || { items: [] };
    }
    findCartChanges(t, e) {
        let r = (t, e) => t.filter((t) => !e.some((e) => t.key == e.key)),
            a = { added: r(e.items, t.items), removed: r(t.items, e.items) };
        return (
            t.items.forEach((t) => {
                let r = e.items.find((e) => e.key == t.key && e.quantity != t.quantity);
                if (!r) return;
                let s = r.quantity - t.quantity,
                    i = { ...r };
                (i.quantity = Math.abs(s)), s > 0 ? a.added.push(i) : a.removed.push(i);
            }),
            a
        );
    }
    async emitCartChanges() {
        let t = await this.fetchCart(),
            e = this.storedCart(),
            r = this.findCartChanges(e, t),
            a = new CustomEvent("cart_changed", { detail: r });
        window.dispatchEvent(a), this.storeCart(t);
    }
    getCurrentTotal() {
        let t = this.storedCart();
        return t.items.reduce((t, e) => t + e.quantity * e.price, 0);
    }
    observeCartChanges() {
        let t = new PerformanceObserver((t) => {
            t.getEntries().forEach((t) => {
                let e = ["xmlhttprequest", "fetch"].includes(t.initiatorType),
                    r = /\/cart\//.test(t.name);
                e && r && this.emitCartChanges();
            });
        });
        t.observe({ entryTypes: ["resource"] });
    }
}
